import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CustomDropdownStore {

}

export enum CustomDropdownStoreKeys {

}
